export const SALE_CHANNEL_RETENTION = 'Retention'
export const SALE_CHANNEL_RENEWAL = 'Renewal_Telesales'
export const SALE_CHANNEL_CTC = 'Renewal_CTC'
